import { useState } from "react";
import { Link } from "react-router-dom";
import { EBOOKS } from "@/data/content";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import EbookModal from "@/components/EbookModal";
import { BookOpen, ArrowUpRight } from "lucide-react";

export default function Ebooks() {
    const [open, setOpen] = useState(false);
    const [ebook, setEbook] = useState(EBOOKS[0]);
    const launch = (e) => { setEbook(e); setOpen(true); };

    return (
        <>
            <PageHeader
                eyebrow="Free eBooks"
                title="Playbooks that actually get you started."
                subtitle="Real guides, no email-then-vanish tricks. Every download comes with the Monday newsletter — unsubscribe anytime."
            />
            <section className="container-editorial pb-24 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {EBOOKS.map((e) => (
                    <article key={e.slug} id={e.slug} data-testid={`ebook-card-${e.slug}`} className="card-editorial rounded-lg overflow-hidden flex flex-col">
                        <div className="aspect-[4/5] overflow-hidden bg-stone-100">
                            <img src={e.cover} alt={e.title} className="w-full h-full object-cover" />
                        </div>
                        <div className="p-6 flex-1 flex flex-col">
                            <p className="label-eyebrow text-accent">{e.pages} pages · Free</p>
                            <h2 className="font-serif text-2xl mt-2 leading-tight">{e.title}</h2>
                            <p className="text-stone-600 text-sm mt-2 flex-1">{e.blurb}</p>
                            <Button
                                onClick={() => launch(e)}
                                data-testid={`ebook-download-${e.slug}`}
                                className="mt-5 rounded-full bg-primary hover:bg-primary/90 h-11 text-primary-foreground w-full"
                            >
                                <BookOpen className="h-4 w-4 mr-2" /> Download free
                            </Button>
                        </div>
                    </article>
                ))}
            </section>
            <section className="container-editorial pb-24">
                <div className="bg-stone-100 rounded-2xl p-10 md:p-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                    <div>
                        <h3 className="font-serif text-3xl leading-tight">Suggest the next playbook</h3>
                        <p className="text-stone-600 mt-2">Missing a topic? Tell us what you'd read next.</p>
                    </div>
                    <Button asChild className="rounded-full bg-primary hover:bg-primary/90 h-12 px-7 text-primary-foreground">
                        <Link to="/contact">Send an idea <ArrowUpRight className="h-4 w-4 ml-1" /></Link>
                    </Button>
                </div>
            </section>
            <EbookModal open={open} onOpenChange={setOpen} ebook={ebook} />
        </>
    );
}
